import type { ReactNode } from "react";
import { useI18nContext } from "@hopper-b2b/i18n";

export interface DisruptionSupportPhoneData {
  supportPhone: string;
  supportPhoneHref?: string;
  contactSupportAt: string;
}

export const useDisruptionSupportPhone = (): DisruptionSupportPhoneData => {
  const { t } = useI18nContext();
  const supportPhone = t(
    "core-disruption.disruptionUniversalExercise.supportPhone",
    { defaultValue: "" }
  );

  return {
    supportPhone,
    supportPhoneHref: supportPhone
      ? `tel:${supportPhone.replace(/[^\d+]/g, "").replace(/^([^+])/, "+$1")}`
      : undefined,
    contactSupportAt: t(
      "core-disruption.disruptionUniversalExercise.contactSupportAt",
      { defaultValue: "Contact support at" }
    ),
  };
};

export interface DisruptionSupportPhoneProps
  extends DisruptionSupportPhoneData {
  children?: ReactNode;
  linkClassName?: string;
}

export const DisruptionSupportPhone = ({
  children,
  contactSupportAt,
  linkClassName,
  supportPhone,
  supportPhoneHref,
}: DisruptionSupportPhoneProps) => (
  <>
    {children} {contactSupportAt}{" "}
    <a className={linkClassName} href={supportPhoneHref}>
      {supportPhone}
    </a>
  </>
);

export default DisruptionSupportPhone;
